import { Box, Grid } from '@mui/material'
import React, { FC } from 'react'

import { IsServiceItem } from '../interfaces/IsServiceItem'
import ServiceItemErrors from './ServiceItemErrors'

interface Props {
  items: IsServiceItem[]
}

const ServiceItemContainerErrors: FC<Props> = ({ items }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'hidden',
        overflowY: 'auto',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        maxHeight: '480px',
        my: 1,
        marginBottom: 0,
      }}
    >
      {items.map((item) => (
        <ServiceItemErrors
          disable={item.disable}
          icon={item.icon}
          key={item.id}
          onClick={item.onClick}
          title={item.title}
        />
      ))}
    </Box>
  )
}

export default ServiceItemContainerErrors
